import { TablerIconGlyph } from "@/shared/ui/icon-picker/tabler-icon-glyph";

export const WorkObjectTypeIconGlyph = TablerIconGlyph;
